var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ManageMyQualification',{attrs:{"staff_id":_vm.$store.getters.currentUserId}}),_c('br'),_c('ManageMySkiil',{attrs:{"staff_id":_vm.$store.getters.currentUserId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }